import { Notyf } from "notyf";

const notyf = new Notyf({
  position: {
    x: "right",
    y: "top",
  },
  duration: 10000,
  dismissible: true,
});

export class ProfileEdit {
  constructor(url, csrf) {
    this.inputs = document.querySelectorAll(".js-edit-input");
    this.buttons = document.querySelectorAll(".js-edit-change");
    this.buttonImgChange = document.querySelector(".js-edit-image-btn");
    this.inputChangeImage = document.querySelector(".js-edit-image-input");
    this.imageChangeStatus = false;
    
    this.tel;

    this.url = url;
    this._csrf = csrf;
    this.elementsGroup = {};

    this.init();
  }

  init() {
    this.validationPluginInit();
    this.createInputElemsObj();
    this.createBtnObj();
    this.addListenersClickOnBtn();
    this.changeImageHandler();
  }

  validationPluginInit() {
    window.$("#user-edit-form").validate({
      submitHandler: function (form) {},
      errorElement: "span",
      errorClass: "_error",
      onkeyup: false,
      errorPlacement: function (error, element) {
        notyf.error(error[0].innerText);
      },
      highlight: function (element, errorClass, validClass) {
        window.$(element).parents(".profile__section").addClass(errorClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        window.$(element).parents(".profile__section").removeClass(errorClass);
      },
      rules: {
        user_name_edit: {
          required: true,
          minlength: 2,
        },
        user_email_edit: {
          required: true,
          email: true,
        },
        user_password_edit: {
          required: true,
          minlength: 7,
        },
        user_edit_phone: {
          required: true,
          minlength: 11,
          regexp: true,
        },
        user_specialization_edit: {
          required: true,
          minlength: 11,
        },
        user_education: {
          required: true,
          minlength: 11,
        },
      },
      messages: {
        user_name_edit: {
          required: "ФИО обязательны для заполнения",
          minlength: "Введите корректное ФИО",
        },
        user_email_edit: {
          required: "Почта обязательна для заполнения",
          email: "Введите адрес электронной почты в формате name@domain.com",
        },
        user_password_edit: {
          required: "Пароль обязателен для заполнения",
          minlength: "Длинна пароля должна составлять минимум 7 символов",
        },
        user_edit_phone: {
          required: "Телефон обязателен для заполнения",
          minlength: "Длина номера должна составлять 11 цифр",
        },
        user_specialization_edit: {
          required: "Поле обязательно для заполнения",
          minlength: "Длина поля должна составлять минимум 11 символов",
        },
        user_education: {
          required: "Поле обязательно для заполнения",
          minlength: "Длина поля должна составлять минимум 11 символов",
        },
      },
    });
  }
  createInputElemsObj() {
    for (let index = 0; index < this.inputs.length; index++) {
      const element = this.inputs[index];
      this.elementsGroup[element.getAttribute("name")] = { input: element };
    }
  }
  createBtnObj() {
    for (let index = 0; index < this.buttons.length; index++) {
      const element = this.buttons[index];
      this.elementsGroup[element.getAttribute("data-edit")] = {
        ...this.elementsGroup[element.getAttribute("data-edit")],
        isEdit: false,
        button: element,
      };
    }
  }
  showLoader(btn) {
    btn.insertAdjacentHTML(
      "beforebegin",
      `<div class="profile__loader loader"></div>`
    );
  }
  removeLoader(btn) {
    btn.parentNode.removeChild(btn.previousSibling);
  }
  sendDataToserver(element, data) {
    const selfEntity = this;
    window.$.ajax({
      type: "POST",
      url: selfEntity.url,
      data,
      dataType: "json",
      beforeSend: function () {
        selfEntity.showLoader(element);
        selfEntity.elementsGroup[
          element.getAttribute("data-edit")
        ].input.setAttribute("disabled", "disabled");
      },
    })
      .done(function (data) {
        selfEntity.elementsGroup[
          element.getAttribute("data-edit")
        ].isEdit = false;

        const { result, errors } = JSON.parse(data);
        if (result === "success") {
          element.innerText = "Изменить";
          notyf.success("Сохранение прошло успешно");
        } else {
          notyf.error(errors);
          selfEntity.elementsGroup[
            element.getAttribute("data-edit")
          ].input.removeAttribute("disabled");
          selfEntity.elementsGroup[
            element.getAttribute("data-edit")
          ].isEdit = true;
        }
      })
      .fail(function () {
        selfEntity.elementsGroup[
          element.getAttribute("data-edit")
        ].input.removeAttribute("disabled");
        notyf.error("Что-то пошло не так");
        selfEntity.elementsGroup[
          element.getAttribute("data-edit")
        ].isEdit = true;
      })
      .always(function () {
        selfEntity.removeLoader(element);
      });
  }
  addListenersClickOnBtn() {
    for (let index = 0; index < this.buttons.length; index++) {
      const element = this.buttons[index];
      element.addEventListener("click", (e) => {
        e.preventDefault();
        const elementGroupIsEdit =
          this.elementsGroup[element.getAttribute("data-edit")].isEdit;
        if (elementGroupIsEdit) {
          if (
            window.$(`[name='${element.getAttribute("data-edit")}']`).valid()
          ) {
            this.elementsGroup[
              element.getAttribute("data-edit")
            ].input.setAttribute("disabled", "disabled");

            let data = {};
            data[element.getAttribute("data-edit")] =
              this.elementsGroup[element.getAttribute("data-edit")].input.value;
            data["_csrf"] = this._csrf;
            const selfEntity = this;
            selfEntity.sendDataToserver(element, data);
            if (this.elementsGroup[element.getAttribute("data-edit")].input.classList.contains('js-tel') ) {
                this.tel.destroy();
            }
          }
        } else {
          this.elementsGroup[element.getAttribute("data-edit")].isEdit = true;
          this.elementsGroup[
            element.getAttribute("data-edit")
          ].input.removeAttribute("disabled");
          this.elementsGroup[element.getAttribute("data-edit")].input.focus();
          if (this.elementsGroup[element.getAttribute("data-edit")].input.classList.contains('js-tel') ) {
                var val = this.elementsGroup[element.getAttribute("data-edit")].input.value;
                this.elementsGroup[element.getAttribute("data-edit")].input.value = '';
                this.tel = window.initTelMaskInput(this.elementsGroup[element.getAttribute("data-edit")].input);
                this.elementsGroup[element.getAttribute("data-edit")].input.dispatchEvent(new Event("countrychange"));
                this.elementsGroup[element.getAttribute("data-edit")].input.value = val;
          }
          
          element.innerText = "Сохранить";
        }
      });
    }
  }
  changeImageHandler() {
    const event = new Event("ProfileImageChangeEvent");
    const inputValidationEvent = document.getElementById(
      "accountform-image_clinic"
    );
    if (!this.buttonImgChange) {
    	return;
    }
    this.buttonImgChange.addEventListener("click", (e) => {
      e.preventDefault();

      this.buttonImgChange.getAttribute("data-text");
      if (this.imageChangeStatus) {
        if (Number(inputValidationEvent.value) === 1) {
          const dataObj = {};
          const inputWithData = document.querySelectorAll(
            ".upload-kit-item input"
          );
          Array.prototype.forEach.call(inputWithData, (item) => {
            dataObj[item.getAttribute("name")] = item.value;
          });
          const selfEntity = this;
          window.$.ajax({
            type: "POST",
            url: selfEntity.url,
            data: dataObj,
            dataType: "json",
            beforeSend: function () {
              selfEntity.showLoader(element);
              selfEntity.inputChangeImage.setAttribute("disabled", "disabled");
            },
          })
            .done(function (data) {
              selfEntity.imageChangeStatus = false;
              const { result, errors } = JSON.parse(data);
              if (result === "success") {
                selfEntity.buttonImgChange.innerText = "Изменить";
                selfEntity.inputChangeImage.setAttribute(
                  "disabled",
                  "disabled"
                );
                notyf.success("Сохранение прошло успешно");
              } else {
                notyf.error(errors);
                selfEntity.imageChangeStatus = true;
                selfEntity.buttonImgChange.innerText = "Сохранить";
              }
            })
            .fail(function () {
              selfEntity.imageChangeStatus = true;
              selfEntity.inputChangeImage.removeAttribute("disabled");
            })
            .always(function () {
              selfEntity.removeLoader(element);
            });
        } else {
          notyf.error("Поле обязательно для заполнения");
        }
      } else {
        document.dispatchEvent(event);
        this.imageChangeStatus = true;
        this.inputChangeImage.removeAttribute("disabled");
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.ProfileEditValidate = ProfileEdit;
  // $("#login-form").modal({
  //   showClose: false,
  // });
});
